export default __webpack_public_path__ + "static/media/my-volunteer-mockup-3.80d749fb.png";